import {
	postBattleshipCompetitorResponse,
	postBattleshipFutureTrendAdoption,
	postBattleshipPrompt,
	postBattleshipResponse,
} from 'services/completions.service'

import { Conversation, DisruptionType } from './types'
import { userMessage } from './utils'

export async function fetchDisruptionPrompt(
	type: DisruptionType,
	params: {
		companyName: string
		companyProblem: string
		conversation: Conversation[]
		topic: string
	}
): Promise<{ promptText: string }> {
	const { companyName, companyProblem, conversation, topic } = params

	if (type === DisruptionType.Future) {
		const response = await postBattleshipFutureTrendAdoption({
			innovationTopic: topic,
			innovationCompany: companyName,
			conversation: [...conversation, userMessage],
			companyProblem,
		})
		if (!response.data?.futureTrend) {
			throw new Error('Missing futureTrend in response')
		}
		return { promptText: response.data.futureTrend }
	} else {
		const response = await postBattleshipPrompt({
			innovationTopic: topic,
			innovationCompany: companyName,
			conversation: [...conversation, userMessage],
			companyProblem,
		})
		if (!response.data?.companyDisruption) {
			throw new Error('Missing companyDisruption in response')
		}
		return { promptText: response.data.companyDisruption }
	}
}

export async function fetchCompanyExamples(params: {
	companyName: string
	promptText: string
	topic: string
}): Promise<string[]> {
	const { companyName, promptText, topic } = params
	const response = await postBattleshipResponse({
		innovationTopic: topic,
		innovationCompany: companyName,
		companyDisruption: promptText,
		conversation: [userMessage],
	})
	if (!response.data?.responses) {
		throw new Error('Missing responses in company examples response')
	}
	return response.data.responses
}

export async function fetchCompetitorResponse(params: {
	companyName: string
	conversation: Conversation[]
	problem: string
	userInput1: string
}): Promise<string[]> {
	const { companyName, conversation, problem, userInput1 } = params
	const response = await postBattleshipCompetitorResponse({
		innovationCompany: companyName,
		problem,
		userInput1,
		conversation,
	})
	if (!response.data?.responses) {
		throw new Error('Missing responses in competitor response')
	}
	return response.data.responses
}
